{
  "paragraph-1": "The information in this application is used to help ensure that we align your prioritised competence development needs and business objectives with relevant learning programs, and when appropriate, invite you to complementary learning teams.",
  "paragraph-2": "The more considered a response you provide the better we will be able to match you to the program and learning team.",
  "Objectives": "Objectives",
  "Objectives_details": "please state two personal and two business objectives for wanting to attend this program.",
  "Contribution": "Contribution",
  "Contribution_details": "what experiences and competencies do you have in this area that you can contribute to the learning experience of other participants?",
  "Challenges": "Challenges",
  "Challenges_details": "please describe some of the main challenges you face personally in your business environment, and if relevant, also describe an initiative you are involved in which you will be working on during the course of this program.",
  "Personal Information": "Personal Information",
  "personal-info-p1": "We value diversity and inclusion as well as providing an equal opportunity for personal and professional development.",
  "personal-info-p2": "In order to help ensure that we as an organisation live up to this it would be helpful if you could provide us with the below information.",
  "Gender identification": "Gender",
  "Select an option": "Select an option",
  "Male": "Male",
  "Female": "Female",
  "Other": "Other",
  "Prefer not to state": "Prefer not to state",
  "Comfort level in English": "English level",
  "(Basic)": "(Basic)",
  "(Native)": "(Native)",
  "First language": "Native language",
  "Geographic location": "Location",
  "Sweden": "Sweden",
  "Denmark": "Denmark",
  "Norway": "Norway",
  "Finland": "Finland",
  "Baltics": "Baltics",
  "Other Europe": "Other Europe",
  "Asia": "Asia",
  "Americas": "Americas",
  "Highest educational degree": "Education level",
  "Current position": "Current position",
  "Team member": "Team member",
  "Team leader": "Team leader",
  "Manager": "Manager",
  "Executive": "Executive",
  "Work experience in current area": "Work experience in current field",
  "years": "years",
  "Management experience": "Management experience",
  "Submit application": "Submit application",
  "Product": "Product",
  "User": "Name",
  "Note": "Response",
  "Applications": "Applications",
  "There are no pending applications": "There are no pending applications.",
  "Reject": "Reject",
  "Approve": "Approve",
  "Location": "Location",
  "Method": "Method",
  "Are you sure that you want to reject this application?": "Are you sure you want to reject this application?",
  "Are you sure that you want to approve this application?": "Are you sure you want to approve this application?",
  "Runs between {{validFrom}} and {{validTo}}": "Valid between {{validFrom}} and {{validTo}}",
  "Runs from {{validFrom}}": "Valid from {{validFrom}}",
  "Runs until {{validTo}}": "Valid until {{validTo}}",
  "Order Id": "Order ID",
  "Your organization has no remaining licenses for this product.": "Your organization has no remaining licenses for this product."
}
